import { Component, forwardRef, input, output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  imports: [FormsModule],
  standalone: true,
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss', './blue-radio-style.scss', 'select-radio-style.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioButtonComponent),
    },
  ],
})
export class RadioButtonComponent implements ControlValueAccessor {
  name = input<string>('');

  index = input.required<number>();

  variant = input<'green' | 'blue' | 'select'>('green');

  optionValue = input.required<any>();

  tabbable = input(true);

  includeResetOption = input(true);
  showResetIcon = input(false);

  dataTestId = input<string | undefined>(undefined);

  resetClicked = output<void>();

  touched = false;

  disabled = false;

  value: any;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (value: any) => void = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
  }

  internalChange(value: any) {
    this.value = value;
    this.onChange!(this.value);
    this.markAsTouched();
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onKeydown(event: KeyboardEvent, index: number) {
    const radios = Array.from(
      document.querySelectorAll<HTMLInputElement>(`input[type="radio"][name="${this.name()}"]`)
    );

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      const next = (index + 1) % radios.length;
      radios[next].focus();
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      const prev = (index - 1 + radios.length) % radios.length;
      radios[prev].focus();
    } else if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      radios[index].click();
    }
  }

  onInputClick(event: MouseEvent): void {
    if (this.value === this.optionValue) {
      event.preventDefault();
      this.value = null;
      this.onChange(null);
      this.onTouched();
      this.touched = true;
    }
  }

  deselect(): void {
    if (this.includeResetOption()) {
      this.value = null;
      this.onChange(null);
      this.onTouched();
    }
  }
}
